import { useAtomValue } from "jotai";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import { Activities } from "../../../types/UserActivityInterfaces";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { useCallback } from "react";
import useUser from "../auth/useUser";

const useUserActivity = () => {
  const tenantID = useAtomValue(tenantIDAtom);
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const queryClient = useQueryClient();
  const { user } = useUser();

  const setUserActivity = useCallback(
    () =>
      async ({ Activity }: { Activity: Activities }) => {
        await TenantAPI.setUserActivity({ WorkspaceID: workspaceID, Activity });
      },
    [workspaceID]
  );

  const userActivity: any = useQuery({
    queryKey: ["userActivity", tenantID],
    queryFn: () =>
      TenantAPI.getUserActivity(user?.id)
        .then((data) => data.data.data)
        .catch(() =>
          queryClient.invalidateQueries({
            queryKey: ["userActivity"],
          })
        ),
    enabled: queriesEnabled,
  });

  return {
    userActivity: userActivity?.data,
    userActivityLoading: userActivity.isLoading,
    setUserActivity: setUserActivity,
  };
};

export default useUserActivity;
